export const environment = {
  production: false,
  oktaBaseUrl: 'https://epson.oktapreview.com',
  oktaIssuer: 'https://epson.oktapreview.com/oauth2/default',
  oktaClientId: '0oa17q1l3otnrpZ3E0h8',
  consoleLogErrors: true,
};
